import { useContext } from "react";
import { Card, Tabs } from "antd";
import { CloudUploadOutlined, HistoryOutlined, UploadOutlined } from "@ant-design/icons";

import PageHeader from "../../components/PageHeader";
import useAuth from "../../hooks/useAuth";
import ImportInvoiceForm from "./components/ImportInvoiceForm";
import CityPendingInvoices from "../CityPendingInvoices";
import { ThemeContext } from "../../contexts/ThemeContext";

export default function CityInvoicesImport() {
    const { theme } = useContext<any>(ThemeContext);
    const isDark = theme === "dark";
    const { user } = useAuth();
    const isAdmin = user?.role?.id === 1;

    const cardBg = isDark ? "#141414" : "#ffffff";
    const cardBorder = isDark ? "#303030" : "#e2e8f0";

    const items = [
        {
            key: "history",
            label: (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontWeight: 600, fontSize: 13.5 }}>
                    <HistoryOutlined />
                    Histórico de importações
                </span>
            ),
            children: <CityPendingInvoices />,
        },
        ...(isAdmin
            ? [
                  {
                      key: "import",
                      label: (
                          <span style={{ display: "inline-flex", alignItems: "center", gap: 6, fontWeight: 600, fontSize: 13.5 }}>
                              <UploadOutlined />
                              Nova importação
                          </span>
                      ),
                      children: <ImportInvoiceForm />,
                  },
              ]
            : []),
    ];

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <PageHeader
                icon={<CloudUploadOutlined />}
                title="Notas Importadas"
                subtitle="Histórico de notas fiscais importadas em lote e envio de novos arquivos XML."
            />

            <Card
                style={{
                    background: cardBg,
                    border: `1px solid ${cardBorder}`,
                    borderRadius: 12,
                    boxShadow: isDark ? "0 2px 8px rgba(0,0,0,0.3)" : "0 1px 3px rgba(0,0,0,0.05)",
                }}
                bodyStyle={{ padding: "12px 18px 20px 18px" }}
            >
                <Tabs
                    defaultActiveKey="history"
                    items={items}
                />
            </Card>
        </div>
    );
}